import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 329.246,
	height: 207.925,
	viewBox: "0 0 329.246 207.925",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_3700",
		"data-name": "Group 3700",
		transform: "translate(-1429.999 -133.031)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5206",
				"data-name": "Path 5206",
				d: "M868.941,767.645s-29.321-52.228-14.661-86.131c17.1-39.537,55.945-57.827,96.21-51.312,37.277,6.031,27.186-29.658,59.8-52.757,69.762-49.409,153.7,19.771,146.523,82.712-6.231,54.683,36.763,54.644,12.683,108.4Z",
				transform: "translate(579.824 -427.605)",
				fill: "#e8f3ff"
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_3694",
				"data-name": "Group 3694",
				transform: "translate(1648.973 191.504)",
				opacity: .2,
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_217",
					"data-name": "Path 217",
					d: "M664.514,1299.228l5.609-4.654a1.614,1.614,0,0,1,1.671-.225q1.06.472,2.176.861a27.077,27.077,0,0,0,4.154,1.1,1.6,1.6,0,0,1,1.29,1.25l1.567,7.454a1.564,1.564,0,0,0,1.733,1.237l6.913-.837a1.547,1.547,0,0,0,1.357-1.547l-.086-7.013a1.553,1.553,0,0,1,1.085-1.516,28.175,28.175,0,0,0,7.869-4.109,1.6,1.6,0,0,1,1.953.05l3.3,2.7a1.62,1.62,0,0,0,2.139-.1l4.916-4.862a1.406,1.406,0,0,0,.256-.323,1.554,1.554,0,0,0-.145-1.8l-3.471-4.193-.848-1.021a27.809,27.809,0,0,0,1.557-3.617,28.257,28.257,0,0,0,1.267-5.1,1.553,1.553,0,0,1,1.22-1.3l6.006-1.255a1.61,1.61,0,0,0,1.268-1.772l-.64-5.286-.187-1.514a1.631,1.631,0,0,0-1.637-1.439l-5.861.067a1.551,1.551,0,0,1-1.51-1.032,27.973,27.973,0,0,0-2.622-5.371,5.01,5.01,0,0,0-.263-.429.833.833,0,0,1-.084-.147,1.589,1.589,0,0,1,.191-1.753l4.377-5.37a1.187,1.187,0,0,0,.133-.189,1.616,1.616,0,0,0-.232-1.942l-4.84-4.907a1.608,1.608,0,0,0-2.169-.109l-5.848,4.856a1.555,1.555,0,0,1-1.753.172,28.4,28.4,0,0,0-3.961-1.729q-1.1-.386-2.216-.673a1.64,1.64,0,0,1-1.19-1.249l-1.508-7.164a1.564,1.564,0,0,0-1.718-1.232l-6.837.839a1.634,1.634,0,0,0-1.442,1.644l.067,5.549a1.605,1.605,0,0,1-1.2,1.578,28.082,28.082,0,0,0-7.965,3.392,1.6,1.6,0,0,1-1.872-.115l-4.838-3.946a1.65,1.65,0,0,0-2.192.1l-4.892,4.819a1.578,1.578,0,0,0-.106,2.136l.2.247,4.035,4.871a1.613,1.613,0,0,1,.16,1.833l0,.007a27.951,27.951,0,0,0-2.038,4.51c-.3.849-.542,1.7-.758,2.557a1.583,1.583,0,0,1-1.214,1.185l-6.1,1.274a1.637,1.637,0,0,0-1.293,1.8l.832,6.81a1.756,1.756,0,0,0,.166.538,1.629,1.629,0,0,0,1.446.875l4.681-.067a1.627,1.627,0,0,1,1.395.782,1.738,1.738,0,0,1,.175.415,27.992,27.992,0,0,0,4.828,9.957,1.574,1.574,0,0,1,.121,1.727,1.592,1.592,0,0,1-.154.224l-3.548,4.346a1.6,1.6,0,0,0,.1,2.131l.111.115,4.713,4.787A1.63,1.63,0,0,0,664.514,1299.228Zm27.47-42.606a18.744,18.744,0,0,1,2.656,2.259,14.714,14.714,0,0,1,3.483,7.222c.032.247.056.491.08.735,1.288,14.887-15.681,22.885-26.378,12.15a15.262,15.262,0,0,1-3.346-6.1,9.963,9.963,0,0,1-.286-1.448,17.3,17.3,0,0,1,.282-5.874A15.1,15.1,0,0,1,691.984,1256.622Z",
					transform: "translate(-647.44 -1232.192)",
					fill: "#89b4fd"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_3686",
				"data-name": "Group 3686",
				transform: "translate(1549.379 161.273)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_1113",
						"data-name": "Rectangle 1113",
						width: 109.679,
						height: 9.205,
						rx: 4.603,
						transform: "translate(26.167 169.024)",
						fill: "#8aa8ff",
						opacity: .6,
						style: {
							mixBlendMode: "multiply",
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_3495",
						"data-name": "Group 3495",
						transform: "translate(35.714 0)",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_59",
								"data-name": "Path 59",
								d: "M1357.61,516.7c0-4.554-3.239-8.246-7.233-8.246H1276.9c-3.995,0-7.233,3.692-7.233,8.246V664.917h0v9.008c0,4.554,3.238,8.246,7.233,8.246h73.474c4,0,7.233-3.692,7.233-8.246v-7.82h0V527.8h0Z",
								transform: "translate(-1264.011 -508.458)",
								fill: "#7284fa"
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_3494",
								"data-name": "Group 3494",
								transform: "translate(0 0)",
								children: [
									/* @__PURE__ */ _jsx("path", {
										id: "Path_60",
										"data-name": "Path 60",
										d: "M1309.71,682.172h-73.474c-3.995,0-7.233-3.692-7.233-8.246V516.7c0-4.554,3.238-8.246,7.233-8.246h73.474c3.995,0,7.233,3.692,7.233,8.246V673.926C1316.943,678.48,1313.7,682.172,1309.71,682.172Z",
										transform: "translate(-1229.003 -508.459)",
										fill: "#d7e4ff"
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_1114",
										"data-name": "Rectangle 1114",
										width: 87.94,
										height: 147.448,
										transform: "translate(0 14.655)",
										fill: "#032677"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Path_61",
										"data-name": "Path 61",
										d: "M1487.305,563.705H1461.34a1.137,1.137,0,0,1-1.047-1.209h0a1.137,1.137,0,0,1,1.047-1.209h25.966a1.137,1.137,0,0,1,1.047,1.209h0A1.137,1.137,0,0,1,1487.305,563.705Z",
										transform: "translate(-1428.107 -553.936)",
										fill: "#8aa8ff"
									})
								]
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_62",
								"data-name": "Path 62",
								d: "M1236.236,509.983h73.474c3.995,0,7.233,3.691,7.233,8.245V516.7c0-4.554-3.238-8.246-7.233-8.245h-73.474c-3.995,0-7.233,3.692-7.233,8.246v1.524C1229,513.675,1232.241,509.983,1236.236,509.983Z",
								transform: "translate(-1229.003 -508.459)",
								fill: "#e9f1ff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_63",
								"data-name": "Path 63",
								d: "M1309.71,1694.836h-73.474c-4,0-7.233-3.692-7.233-8.245v1.524c0,4.554,3.238,8.246,7.233,8.245h73.474c3.995,0,7.233-3.692,7.233-8.245v-1.524C1316.943,1691.145,1313.7,1694.836,1309.71,1694.836Z",
								transform: "translate(-1229.003 -1522.648)",
								fill: "#c4d5f2"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_64",
								"data-name": "Path 64",
								d: "M1860.958,1000.565l5.659-2.681v4.393l-5.659,2.457Z",
								transform: "translate(-1773.018 -929.778)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_65",
								"data-name": "Path 65",
								d: "M1860.958,810.313l5.659-2.383v1.415l-5.659,2.457Z",
								transform: "translate(-1773.018 -766.257)",
								fill: "#fff"
							})
						]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_3498",
						"data-name": "Group 3498",
						transform: "translate(0.001 31.284)",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_66",
								"data-name": "Path 66",
								d: "M972.359,827.441l110.773.263v-93.7H972.359Z",
								transform: "translate(-972.359 -733.904)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_1115",
								"data-name": "Rectangle 1115",
								width: 82.981,
								height: 10.782,
								rx: 5.391,
								transform: "translate(13.908 35.521)",
								fill: "#d9edf9"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_1116",
								"data-name": "Rectangle 1116",
								width: 82.981,
								height: 10.782,
								rx: 5.391,
								transform: "translate(13.908 54.972)",
								fill: "#d9edf9"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_73",
								"data-name": "Path 73",
								d: "M5.391,0h72.2a5.391,5.391,0,1,1,0,10.782H5.391A5.391,5.391,0,1,1,5.391,0Z",
								transform: "translate(13.908 74.422)",
								fill: "#2cd3c4"
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_3497",
								"data-name": "Group 3497",
								transform: "translate(48.407 78.354)",
								children: [
									/* @__PURE__ */ _jsx("path", {
										id: "Path_67",
										"data-name": "Path 67",
										d: "M1320.221,1296.54h.337v2.893h1.783v.291h-2.12Z",
										transform: "translate(-1320.221 -1296.512)",
										fill: "#fff"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Path_68",
										"data-name": "Path 68",
										d: "M1337.806,1299.371a1.543,1.543,0,0,1-.6-.58,1.693,1.693,0,0,1,0-1.656,1.547,1.547,0,0,1,.6-.58,1.845,1.845,0,0,1,1.71,0,1.549,1.549,0,0,1,.6.58,1.687,1.687,0,0,1,0,1.661,1.549,1.549,0,0,1-.6.58,1.843,1.843,0,0,1-1.71,0Zm1.54-.259a1.232,1.232,0,0,0,.478-.473,1.406,1.406,0,0,0,0-1.351,1.232,1.232,0,0,0-.478-.473,1.454,1.454,0,0,0-1.367,0,1.246,1.246,0,0,0-.482.473,1.389,1.389,0,0,0,0,1.351,1.245,1.245,0,0,0,.482.473,1.452,1.452,0,0,0,1.367,0Z",
										transform: "translate(-1334.656 -1296.344)",
										fill: "#fff"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Path_69",
										"data-name": "Path 69",
										d: "M1366.94,1297.963h.323v1.215a1.545,1.545,0,0,1-.527.3,1.951,1.951,0,0,1-.641.1,1.758,1.758,0,0,1-.86-.209,1.542,1.542,0,0,1-.6-.58,1.687,1.687,0,0,1,0-1.661,1.542,1.542,0,0,1,.6-.58,1.768,1.768,0,0,1,.864-.209,1.86,1.86,0,0,1,.669.116,1.327,1.327,0,0,1,.514.343l-.209.214a1.309,1.309,0,0,0-.96-.373,1.43,1.43,0,0,0-.7.171,1.254,1.254,0,0,0-.489.473,1.37,1.37,0,0,0,0,1.349,1.278,1.278,0,0,0,.487.473,1.4,1.4,0,0,0,.7.173,1.386,1.386,0,0,0,.832-.246Z",
										transform: "translate(-1358.266 -1296.344)",
										fill: "#fff"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Path_70",
										"data-name": "Path 70",
										d: "M1391.711,1296.54h.337v3.184h-.337Z",
										transform: "translate(-1381.763 -1296.512)",
										fill: "#fff"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Path_71",
										"data-name": "Path 71",
										d: "M1404.243,1296.54v3.184h-.277l-2.047-2.584v2.584h-.337v-3.184h.277l2.052,2.584v-2.584Z",
										transform: "translate(-1390.26 -1296.512)",
										fill: "#fff"
									})
								]
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_1118",
								"data-name": "Rectangle 1118",
								width: 56.373,
								height: 2.308,
								rx: 1.154,
								transform: "translate(17.796 39.709)",
								fill: "#032677"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_97",
								"data-name": "Ellipse 97",
								cx: 1.944,
								cy: 1.944,
								rx: 1.944,
								ry: 1.944,
								transform: "translate(17.509 62.213) rotate(-80.783)",
								fill: "#032677"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_98",
								"data-name": "Ellipse 98",
								cx: 1.944,
								cy: 1.944,
								rx: 1.944,
								ry: 1.944,
								transform: "translate(23.962 62.051) rotate(-76.718)",
								fill: "#032677"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_99",
								"data-name": "Ellipse 99",
								cx: 1.944,
								cy: 1.944,
								rx: 1.944,
								ry: 1.944,
								transform: "translate(30.631 62.213) rotate(-80.783)",
								fill: "#032677"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_100",
								"data-name": "Ellipse 100",
								cx: 1.944,
								cy: 1.944,
								rx: 1.944,
								ry: 1.944,
								transform: "translate(37.083 62.051) rotate(-76.718)",
								fill: "#032677"
							}),
							/* @__PURE__ */ _jsx("circle", {
								id: "Ellipse_101",
								"data-name": "Ellipse 101",
								cx: 1.944,
								cy: 1.944,
								r: 1.944,
								transform: "translate(43.233 60.606) rotate(-45)",
								fill: "#032677"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_102",
								"data-name": "Ellipse 102",
								cx: 1.944,
								cy: 1.944,
								rx: 1.944,
								ry: 1.944,
								transform: "translate(50.204 62.051) rotate(-76.718)",
								fill: "#032677"
							}),
							/* @__PURE__ */ _jsx("circle", {
								id: "Ellipse_103",
								"data-name": "Ellipse 103",
								cx: 1.944,
								cy: 1.944,
								r: 1.944,
								transform: "translate(56.355 60.606) rotate(-45)",
								fill: "#032677"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_104",
								"data-name": "Ellipse 104",
								cx: 1.944,
								cy: 1.944,
								rx: 1.944,
								ry: 1.944,
								transform: "translate(63.326 62.051) rotate(-76.718)",
								fill: "#032677"
							}),
							/* @__PURE__ */ _jsx("circle", {
								id: "Ellipse_105",
								"data-name": "Ellipse 105",
								cx: 1.944,
								cy: 1.944,
								r: 1.944,
								transform: "translate(69.476 60.606) rotate(-45)",
								fill: "#032677"
							}),
							/* @__PURE__ */ _jsx("circle", {
								id: "Ellipse_106",
								"data-name": "Ellipse 106",
								cx: 12.271,
								cy: 12.271,
								r: 12.271,
								transform: "translate(37.984 17.354) rotate(-45)",
								fill: "#f7e7f2"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_72",
								"data-name": "Path 72",
								d: "M1319.051,814.241a5.972,5.972,0,1,0-5.539,0,9.662,9.662,0,0,0-5.918,5.058,12.27,12.27,0,0,0,17.375,0A9.661,9.661,0,0,0,1319.051,814.241Z",
								transform: "translate(-1260.944 -793.279)",
								fill: "#b8d4f5"
							})
						]
					})
				]
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_3693",
				"data-name": "Group 3693",
				transform: "translate(994.09 -99.399)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_188",
					"data-name": "Group 188",
					transform: "translate(473.501 286.19)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_187",
						"data-name": "Group 187",
						transform: "translate(0 0)",
						children: [
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_179",
								"data-name": "Group 179",
								transform: "translate(11.26)",
								children: [
									/* @__PURE__ */ _jsx("g", {
										id: "Group_178",
										"data-name": "Group 178",
										transform: "translate(7.403 58.104)",
										children: /* @__PURE__ */ _jsx("path", {
											id: "Path_359",
											"data-name": "Path 359",
											d: "M728.284,1007.669l2.482,6.541a12.184,12.184,0,0,1-7.061,15.695l-21.309,8.088a12.183,12.183,0,0,1-15.695-7.061l-2.482-6.54a12.183,12.183,0,0,1,7.061-15.695l21.309-8.088A12.184,12.184,0,0,1,728.284,1007.669Zm-34.863,20.711a4.987,4.987,0,0,0,6.425,2.889l21.309-8.088a4.987,4.987,0,0,0,2.891-6.425l-2.482-6.54a4.987,4.987,0,0,0-6.425-2.89l-21.309,8.088a4.987,4.987,0,0,0-2.891,6.425Z",
											transform: "translate(-683.428 -999.819)",
											fill: "#002c75"
										})
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Path_360",
										"data-name": "Path 360",
										d: "M634.724,568.154l22.758,59.984-7.85,2.978-22.758-59.984a4.2,4.2,0,0,1,2.436-5.415h0A4.2,4.2,0,0,1,634.724,568.154Z",
										transform: "translate(-626.6 -563.922)",
										fill: "#002c75"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Rectangle_69",
										"data-name": "Rectangle 69",
										d: "M682.8,566.125l-2.391-6.3h0l15.384-5.837a3.374,3.374,0,0,1,4.351,1.957h0a3.374,3.374,0,0,1-1.957,4.351L682.8,566.133Z",
										transform: "translate(-673.399 -553.767)",
										fill: "#002c75"
									})
								]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_180",
								"data-name": "Group 180",
								transform: "translate(6.328 72.736)",
								children: [/* @__PURE__ */ _jsx("path", {
									id: "Path_361",
									"data-name": "Path 361",
									d: "M621.086,1134.857a2.224,2.224,0,0,0,.8-1.575s-10.049-8.227-11.067-8.9c-.695-.457-7.7-7.163-11.554-11.017-1.856-1.853-3.841-1.214-6.273-.516l-2,.575a3.348,3.348,0,0,0-1.063,5.719c5.588,4.623,14.883,9.834,16.618,10.928a95.872,95.872,0,0,0,12.769,5.944A5.349,5.349,0,0,0,621.086,1134.857Z",
									transform: "translate(-588.742 -1112.153)",
									fill: "#3e56f4"
								}), /* @__PURE__ */ _jsx("path", {
									id: "Path_362",
									"data-name": "Path 362",
									d: "M829.512,1271.889l1.087.883s2.975-1.067,3.647,2.469c0,0,.179,1.507-.776,1.509a19.014,19.014,0,0,0-1.913-.125,2.445,2.445,0,0,1-2.669-1.769l-.646-.929Z",
									transform: "translate(-797.045 -1251.081)",
									fill: "#f38956"
								})]
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_363",
								"data-name": "Path 363",
								d: "M903.648,1674.452a7.574,7.574,0,0,0,6.175.862s3.012-.686,3.673.816c0,0-4.623,2.348-5.79,2.989a13.989,13.989,0,0,0-2.45,1.838,1.212,1.212,0,0,1-1.712-.091l-.038-.044c-.2-.25-.436-.548-.691-.893-.712-.966-2.374-4.083-2.374-4.083Z",
								transform: "translate(-853.511 -1528.469)",
								fill: "#183b60"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_364",
								"data-name": "Path 364",
								d: "M685.054,1376.417s-1.486,3.423-4.913,2.794a95.673,95.673,0,0,1-11.792-11.776,26.652,26.652,0,0,1-3.663-5.726c-3.181-7.366-11.769-18.351-17.228-23.921l13.659-4.942s4.373,8.8,10.2,19.617C675.5,1360.247,680.45,1369.08,685.054,1376.417Z",
								transform: "translate(-633.481 -1231.361)",
								fill: "#174c87"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_365",
								"data-name": "Path 365",
								d: "M671.285,1352.468l-2.964,14.976a26.651,26.651,0,0,1-3.664-5.726c-3.181-7.366-11.769-18.351-17.228-23.92l13.66-4.942S665.464,1341.657,671.285,1352.468Z",
								transform: "translate(-633.457 -1231.37)",
								fill: "#183b60"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_366",
								"data-name": "Path 366",
								d: "M712.089,1679.7a3.1,3.1,0,0,0,3.093,3.1h.071s1.892.01,1.9,1.749l-9.621.03a7.488,7.488,0,0,1-.347-2.2,17.193,17.193,0,0,1,1.118-4.17Z",
								transform: "translate(-685.425 -1531.732)",
								fill: "#183b60"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_367",
								"data-name": "Path 367",
								d: "M629.3,1328.8a54.632,54.632,0,0,1,9.947,18.732c2.1,6.555-3.852,23.033-5.013,28.758a18.249,18.249,0,0,1-6.725-.717,132.493,132.493,0,0,1,1.39-20.94c.893-5.1-8.012-10.909-11.9-20.126-2.648-6.27.573-6.164,4.531-6.314Z",
								transform: "translate(-606.145 -1227.315)",
								fill: "#174c87"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_368",
								"data-name": "Path 368",
								d: "M595.082,1048.749c-3.385,1.912-10.317.149-10.317.149a9.655,9.655,0,0,0,1.536-8.4l2.658,1.351,2.855,1.451a23.69,23.69,0,0,1,.314,2.559c.032.423.061.9.082,1.413A8.883,8.883,0,0,1,595.082,1048.749Z",
								transform: "translate(-578.955 -977.095)",
								fill: "#ffab7f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_369",
								"data-name": "Path 369",
								d: "M590.454,1122.451c0,.595-.685.875-.831.909-1.366.25-5.178,1.733-8.613,2.073a27.53,27.53,0,0,1-8.528-.577c-.391-.079-1.308-.325-1.374-.7-.081-.409-11.378-23.031-2.6-32.748.206-.227,1.94.182,3.525.558a6.5,6.5,0,0,0,4.006-.327l1.487.782c1.826,1.017,5.28,4.632,5.684,7.468.2,1.442,1.031,2.51,1.269,3.779q.133.7.271,1.374.27,1.315.556,2.5c.516,2.146,1.062,3.992,1.6,5.587.57,1.694,1.125,3.1,1.624,4.282.647,1.528,1.194,2.67,1.537,3.545A4.377,4.377,0,0,1,590.454,1122.451Z",
								transform: "translate(-561.913 -1021.317)",
								fill: "#7284fa"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_370",
								"data-name": "Path 370",
								d: "M613,1172.268a44.387,44.387,0,0,1-21.47-21.941s12.957,4.779,16.152,6.024q.27,1.314.556,2.5c.516,2.145,1.062,3.992,1.6,5.586.57,1.694,1.125,3.1,1.624,4.282C612.109,1170.25,612.655,1171.394,613,1172.268Z",
								transform: "translate(-584.836 -1072.618)",
								fill: "#3e56f4"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_371",
								"data-name": "Path 371",
								d: "M823.15,1284.775l1.374.5A2.947,2.947,0,0,1,829,1286.5s.625,1.386-.362,1.687-.625.017-2.008.479a2.634,2.634,0,0,1-3.267-.858l-.937-.687Z",
								transform: "translate(-785.659 -1189.48)",
								fill: "#ffab7f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_372",
								"data-name": "Path 372",
								d: "M609.168,1141.077c.51-1.329.742-1.932.742-1.932s-10.413-8.488-11.474-9.215c-.722-.5-7.92-5.872-11.43-10.07a7.345,7.345,0,0,0-7.14-2.474l-2.187.459a3.249,3.249,0,0,0-1.449,5.649c5.766,4.943,15.494,10.677,17.305,11.87,4.5,2.96,14.459,7.109,14.459,7.109A2.564,2.564,0,0,0,609.168,1141.077Z",
								transform: "translate(-570.543 -1043.832)",
								fill: "#7284fa"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_373",
								"data-name": "Path 373",
								d: "M604.574,1054.836a7.123,7.123,0,0,1-5.5-2.562,26.4,26.4,0,0,0,2.327-1.447l2.855,1.451A23.732,23.732,0,0,1,604.574,1054.836Z",
								transform: "translate(-591.401 -986.08)",
								fill: "#f38956"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_374",
								"data-name": "Path 374",
								d: "M585.174,998.722s-5.044,3.624-7.247.444-4.343-4.848-1.216-7.295,4.6-1.673,5.6-.792S586.43,997.693,585.174,998.722Z",
								transform: "translate(-570.583 -933.373)",
								fill: "#ffab7f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_375",
								"data-name": "Path 375",
								d: "M552.415,960.822a8.125,8.125,0,0,0-.587-2.081s-.316,1.312-2.713,1.125-6.2.236-7.461,2.966a4.625,4.625,0,0,0-.216.536,6.322,6.322,0,0,1-.285-1.513,4.666,4.666,0,0,0,0,2.646h0c-.007.043-.013.086-.019.125a5.34,5.34,0,0,0-.973,1.837,1.665,1.665,0,0,1,.9-.8c-.01,2.124.851,4.2,2.364,4.821,2.212.9,2.194.215,4.418,1.691,0,0,.6-.74.19-1.238s-1.944-1.221-1.086-1.944,1.176.09,1.492-.407-1.266-1.944.768-3.3S552.6,962.043,552.415,960.822Z",
								transform: "translate(-540.161 -905.989)",
								fill: "#183b60"
							})
						]
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_3695",
				"data-name": "Group 3695",
				transform: "translate(1714.63 160.016)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_218",
					"data-name": "Path 218",
					d: "M808.374,1185.794l3.483-2.89a1,1,0,0,1,1.037-.14q.659.293,1.351.535a16.853,16.853,0,0,0,2.58.686.99.99,0,0,1,.8.777l.973,4.629a.971.971,0,0,0,1.076.768l4.293-.52a.961.961,0,0,0,.843-.962l-.054-4.355a.965.965,0,0,1,.674-.942,17.493,17.493,0,0,0,4.887-2.552,1,1,0,0,1,1.213.031l2.05,1.678a1.006,1.006,0,0,0,1.328-.059l3.052-3.019a.881.881,0,0,0,.159-.2.965.965,0,0,0-.09-1.119l-2.156-2.6-.527-.634a17.287,17.287,0,0,0,.967-2.246,17.589,17.589,0,0,0,.787-3.167.964.964,0,0,1,.758-.808l3.73-.779a1,1,0,0,0,.787-1.1l-.4-3.282-.116-.94a1.013,1.013,0,0,0-1.016-.894l-3.64.042a.964.964,0,0,1-.937-.641,17.362,17.362,0,0,0-1.629-3.336,3.044,3.044,0,0,0-.163-.266.517.517,0,0,1-.052-.092.987.987,0,0,1,.119-1.088l2.718-3.335a.716.716,0,0,0,.082-.118,1,1,0,0,0-.143-1.206L834.2,1148.6a1,1,0,0,0-1.347-.068l-3.632,3.016a.965.965,0,0,1-1.089.106,17.673,17.673,0,0,0-2.46-1.074q-.685-.239-1.376-.418a1.017,1.017,0,0,1-.739-.776l-.936-4.449a.971.971,0,0,0-1.067-.765l-4.246.52a1.015,1.015,0,0,0-.9,1.022l.042,3.446a1,1,0,0,1-.745.979,17.434,17.434,0,0,0-4.946,2.107.991.991,0,0,1-1.162-.071l-3-2.451a1.025,1.025,0,0,0-1.361.063l-3.038,2.993a.98.98,0,0,0-.066,1.327l.125.153,2.506,3.025a1,1,0,0,1,.1,1.139v0a17.318,17.318,0,0,0-1.266,2.8c-.184.527-.337,1.054-.471,1.588a.983.983,0,0,1-.754.736l-3.786.791a1.016,1.016,0,0,0-.8,1.116l.516,4.229a1.1,1.1,0,0,0,.1.334,1.012,1.012,0,0,0,.9.544l2.907-.041a1.011,1.011,0,0,1,.866.485,1.087,1.087,0,0,1,.109.258,17.38,17.38,0,0,0,3,6.184.977.977,0,0,1,.076,1.072,1.028,1.028,0,0,1-.1.139l-2.2,2.7a1,1,0,0,0,.061,1.324l.069.071,2.927,2.973A1.013,1.013,0,0,0,808.374,1185.794Zm17.058-26.458a11.65,11.65,0,0,1,1.65,1.4,9.143,9.143,0,0,1,2.164,4.485c.019.153.034.305.049.457.8,9.245-9.738,14.211-16.381,7.545a9.474,9.474,0,0,1-2.078-3.786,6.183,6.183,0,0,1-.178-.9,10.743,10.743,0,0,1,.175-3.647A9.375,9.375,0,0,1,825.433,1159.335Z",
					transform: "translate(-797.771 -1144.165)",
					fill: "#a9c2ff"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_3696",
				"data-name": "Group 3696",
				transform: "translate(1677.987 141.063)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_219",
					"data-name": "Path 219",
					d: "M716.42,1164.212l2-2.552a.718.718,0,0,1,.7-.256q.505.1,1.026.168a12.087,12.087,0,0,0,1.91.087.708.708,0,0,1,.678.421l1.386,3.09a.7.7,0,0,0,.87.374l2.924-1.018a.688.688,0,0,0,.443-.8l-.7-3.039a.69.69,0,0,1,.328-.761,12.53,12.53,0,0,0,3.031-2.529.712.712,0,0,1,.853-.163l1.69.862a.72.72,0,0,0,.92-.244l1.676-2.578a.625.625,0,0,0,.081-.165.691.691,0,0,0-.234-.769l-1.905-1.494-.465-.363a12.413,12.413,0,0,0,.334-1.719,12.589,12.589,0,0,0,.068-2.336.69.69,0,0,1,.407-.681l2.491-1.113a.716.716,0,0,0,.383-.89l-.778-2.236-.225-.641a.725.725,0,0,0-.847-.47l-2.54.584a.69.69,0,0,1-.754-.306,12.384,12.384,0,0,0-1.648-2.086,2.11,2.11,0,0,0-.155-.162.384.384,0,0,1-.05-.056.707.707,0,0,1-.083-.78l1.394-2.747a.539.539,0,0,0,.04-.1.719.719,0,0,0-.284-.822l-2.567-1.674a.716.716,0,0,0-.953.157l-2.082,2.663a.691.691,0,0,1-.745.24,12.67,12.67,0,0,0-1.885-.377q-.516-.063-1.026-.082a.728.728,0,0,1-.635-.431l-1.333-2.97a.7.7,0,0,0-.863-.373l-2.891,1.011a.727.727,0,0,0-.471.851l.554,2.4a.714.714,0,0,1-.372.8,12.484,12.484,0,0,0-3.14,2.227.709.709,0,0,1-.824.128l-2.475-1.257a.734.734,0,0,0-.943.252l-1.67,2.557a.7.7,0,0,0,.156.938l.11.088,2.214,1.735a.717.717,0,0,1,.243.781v0a12.418,12.418,0,0,0-.459,2.153c-.048.4-.075.789-.087,1.183a.7.7,0,0,1-.416.63l-2.528,1.13a.728.728,0,0,0-.392.9l1.005,2.88a.782.782,0,0,0,.123.218.725.725,0,0,0,.711.244l2.028-.472a.724.724,0,0,1,.68.208.774.774,0,0,1,.115.164,12.448,12.448,0,0,0,3.039,3.869.7.7,0,0,1,.216.739.72.72,0,0,1-.046.112l-1.13,2.224a.712.712,0,0,0,.244.917l.059.039,2.5,1.635A.725.725,0,0,0,716.42,1164.212Zm7.905-21.11a8.364,8.364,0,0,1,1.368.73,6.547,6.547,0,0,1,2.2,2.809c.037.1.071.208.1.312a6.761,6.761,0,0,1-12.342,5.442,4.492,4.492,0,0,1-.261-.6,7.7,7.7,0,0,1-.433-2.579A6.713,6.713,0,0,1,724.326,1143.1Z",
					transform: "translate(-705.87 -1133.046)",
					fill: "#2cd5c4"
				})
			})
		]
	})
});
export default SvgUsers;
